// export { default } from './ResponsiveMenuItems';
import { withFeatureBranch } from '../../../redux/flags';
import ResponsiveMenuItems from './ResponsiveMenuItems';
import ResponsiveMenuItemsWithGroupsInTopNav from './ResponsiveMenuItems.my_groups_in_top_nav';
export default withFeatureBranch({
    my_groups_in_top_nav: ResponsiveMenuItemsWithGroupsInTopNav,
})(ResponsiveMenuItems);
//# sourceMappingURL=index.js.map